import Favorite from '@/js/plugins/CookieDb/Favorite';
import { requestFetch, authCheck } from '@/js/helpers';

const main = async () => {
    const favorite = new Favorite();
    const target = authCheck() ? 'db' : 'cookie';

    // イベント委譲（Ajax読み込み後のボタンにも対応）
    document.addEventListener('click', async (e) => {
        const obj = e.target.closest('.c-buttons-favorite');
        if (!obj) return;
        const id = obj.dataset.id;
        if (!id) return;

        const prevState = obj.hasAttribute('data-active');
        const nextState = !prevState;
        if (nextState) {
            obj.dataset.active = '';
        } else {
            delete obj.dataset.active;
        }
        const resp = await favorite.setState(target, id, nextState);
        if (!resp) {
            if (prevState) {
                obj.dataset.active = '';
            } else {
                delete obj.dataset.active;
            }
        }
        favorite.getAll(target).then((favorites) => {
            if (document.querySelector('[data-favorite-count]')) {
                document.querySelectorAll('[data-favorite-count]').forEach((targetObj) => {
                    targetObj.textContent = favorites.length < 99 ? favorites.length : '99+';
                    targetObj.dataset.count = favorites.length;
                });
            }

            // 同ページ内にある同IDのお気に入りボタンをすべて同期
            document.querySelectorAll(`[data-type="favorite"][data-id="${id}"], .c-buttons-favorite[data-id="${id}"]`).forEach((targetObj) => {
                if (nextState) {
                    targetObj.dataset.active = '';
                } else {
                    delete targetObj.dataset.active;
                }
            });
        });
    });

    // お気に入りボタン初期表示（追加・削除どちらも反映）
    const applyFavoriteState = () => {
        favorite.getAll(target).then((favorites) => {
            document.querySelectorAll('.c-buttons-favorite').forEach((obj) => {
                if (favorites.includes(obj.dataset.id)) {
                    obj.dataset.active = '';
                } else {
                    delete obj.dataset.active;
                }
            });
        });
    };

    // 通常表示分
    applyFavoriteState();

    // Ajax読み込み完了後にも再実行
    document.querySelectorAll('.js-load-contents').forEach((obj) => {
        obj.addEventListener('onLoadContents', () => {
            applyFavoriteState();
        });
    });
}

export default main;
